import {
  CandidateBuilder,
  GetShareCandidatesInput,
  GetShareCandidatesOutput,
} from '../candidates.types';

export const getShareCandidate = (builder: CandidateBuilder) =>
  builder.mutation<GetShareCandidatesOutput, GetShareCandidatesInput>({
    query: (query) => ({
      url: '/candidates/share',
      method: 'POST',
      body: {
        Name: query.name,
        Ids: query.ids,
        ...(query.fee !== undefined && { Fee: query.fee }),
      },
    }),
  });
